import { Injectable } from "@angular/core";
import { BindingTypeEnum } from "../enums";

@Injectable()
export class RoutesConstants {
  public static WELCOME(uuid?: string): string { return `/tools/initial${uuid ? ('/' + uuid) : ''}`};
  public static SCAN_CLIENT(uuid: string, type: BindingTypeEnum): string { return `/scan-client/${uuid}/${type}` };

  //B2B
  public static SELECT_DOOR(uuid: string): string { return `/${uuid}/B2B/select-door` };
  public static SELECT_GATEWAY(uuid: string): string { return `/${uuid}/B2B/select-gateway` };
  public static BINDING_PROCESS_B2B(uuid: string): string { return `/${uuid}/B2B/binding-process` };

  //B2C
  public static SELECT_LOCATION(uuid: string): string { return `/${uuid}/B2C/select-location` };
  public static CREATE_LOCATION(uuid: string): string { return `/${uuid}/B2C/create-location` };
  public static BINDING_PROCESS_B2C(uuid: string): string { return `/${uuid}/B2C/binding-process` };
}